import {t} from '@lingui/core/macro';

export const translateIncidentStatus = (resolved: boolean): string => {
    return resolved ? t`Решён` : t`Не решён`;
};
